export const lightTheme = {
    background: "#fff", // fundo branco
    hoverBackground: "#e9e9e9",

    main: "#268F7C", // verde principal
    overMain: "#fff", // branco em cima do verde
    hoverMain: "#197867",

    secondary: "#606060", // cor secundária
    overSecondary: "#fff", //
    hoverSecondary: "#4a4949",

    special: "#DD4661", // cor do like, notificações

    right: "#268F7C", // verde para correto
    neutral: "#B0B0B0", // cinza para não preenchido
    wrong: "#C93333", // vermelho para errado

    light: "#fff", // cor clara do tema
    gray: "#B0B0B0", // cor cinza do tema
    lightGray: "#E2E2E2", // cor cinza do tema
    dark: "#000", // cor escura do tema

    simpleText: "#000", // cor de texto básico
    linkText: "#268F7C", // cor de links
};

export const darkTheme = {
    background: "#fff", // fundo branco

    main: "#268F7C", // verde principal
    overMain: "#fff", // branco em cima do verde

    secondary: "#B0B0B0", // cor secundária
    overSecondary: "#fff", //

    special: "#DD4661", // cor do like, notificações

    wright: "#268F7C", // verde para correto
    neutral: "#B0B0B0", // cinza para não preenchido
    wrong: "#C93333", // vermelho para errado

    light: "#fff", // cor clara do tema
    gray: "#B0B0B0", // cor cinza do tema
    dark: "#000", // cor escura do tema

    simpleText: "#000", // cor de texto básico
    linkText: "#268F7C", // cor de links
};
